module.exports = __webpack_public_path__ + "static/media/fruits_32.94dd16d7.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_32.csv
// module id = 698
// module chunks = 0